import React, { FC } from 'react'
import ModalTemplate from 'uiKit/ModalTemplate'
import SubmitButton from 'uiKit/buttons/SubmitButton'
import classes from './styles.module.scss'

const BRAND_BLUE = '#00A0E3'

interface Props {
  open: boolean
  successfullyImported: number
  onClose: () => void
}

export const BulkInviteImportSuccessModal: FC<Props> = ({
  open,
  successfullyImported,
  onClose,
}) => {
  const userLabel = successfullyImported === 1 ? 'user was' : 'users were'

  return (
    <ModalTemplate
      title="Import Successful"
      open={open}
      onClose={onClose}
      withFooter={false}
      containerClasses={classes.modalContainer}
    >
      <>
        <div className={classes.body}>
          <p className={classes.message}>
            {successfullyImported} {userLabel} imported successfully.
          </p>
        </div>
        <div className={classes.footer}>
          <SubmitButton
            title="Okay"
            type="primary_with_border"
            styles={{
              borderRadius: 8,
              paddingLeft: 56,
              paddingRight: 56,
              paddingTop: 12,
              paddingBottom: 12,
              color: BRAND_BLUE,
              borderColor: BRAND_BLUE,
            }}
            onClick={onClose}
          />
        </div>
      </>
    </ModalTemplate>
  )
}
